import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { CourseCardComponent } from '../course-card/course-card.component';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';
@Component({
  standalone: true,
  selector: 'app-course-list',
  imports: [CommonModule, CourseCardComponent],
  templateUrl: './course-list.component.html',
  styleUrl: './course-list.component.scss',
})
export class CourseListComponent {
  courses = input<ChallengeGen.Course[]>([]);

  constructor(private router: Router) {}

  openCourse(courseId: ChallengeGen.Course['id']): void {
    if (courseId === undefined || courseId === null) {
      return;
    }

    void this.router.navigate(['/courses', courseId]);
  }
}
